const AGENT_STUDIO_URL =
  process.env.REACT_APP_AGENT_STUDIO_URL ||
  "https://studio.quadroid.ai/";

function studioOrigin() {
  try {
    return new URL(AGENT_STUDIO_URL).origin;
  } catch {
    return "*";
  }
}

export const openAgentStudio = (authData = null) => {
  let url = AGENT_STUDIO_URL;

  if (authData) {
    const params = new URLSearchParams();
    if (authData.api_key) params.set("api_key", btoa(authData.api_key));
    if (authData.first_name) params.set("first_name", btoa(authData.first_name));
    if (authData.last_name) params.set("last_name", btoa(authData.last_name));
    if (authData.token) params.set("token", btoa(authData.token));
    const email = authData.email || authData.userEmail;
    if (email) params.set("email", btoa(email));
    if (authData.userData) params.set("userData", btoa(JSON.stringify(authData.userData)));

    url += (url.includes("?") ? "&" : "?") + params.toString();
  }

  const win = window.open(url, "_blank");
  if (!win || !authData) return win;

  const origin = studioOrigin();
  setTimeout(() => {
    try {
      win.postMessage({ type: "AUTH_DATA", data: authData }, origin === "*" ? "*" : origin);
    } catch (e) {
      console.warn("postMessage to Agent Studio failed:", e);
    }
  }, 1000);

  return win;
};
